import { useQuery } from "@tanstack/react-query";
import { getServiceContexts } from "@/api/authorization";
import { useAuth } from "@/features/auth/hooks/useAuth";
export function useServiceNavigation() {
  const { churchId } = useAuth();
  const query = useQuery({ queryKey: ["service-contexts", churchId], queryFn: () => getServiceContexts(churchId!), enabled: !!churchId });
  const context = query.data?.[0];
  return context ? context.ministry_id ? `/services?ministry_id=${context.ministry_id}` : "/services" : undefined;
}
